import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import _ from 'underscore';
import { withStyles } from '@material-ui/core';
import { Button, TextField, CircularProgress } from '@material-ui/core';
import { Portlet, PortletHeader, PortletLabel, PortletContent, PortletFooter } from 'components';
import { getCurrentInfo } from 'api';
import { updateUser } from 'actions/authActions'; // Fonction de mise à jour

import styles from './styles';
import schema from './schema';

class Account extends Component {
  state = {
    values: {
      name: '',
      email: '',
    },
    touched: {
      name: false,
      email: false,
    },
    errors: {
      name: null,
      email: null,
    },
    isValid: false,
    loading: true, // Chargement au départ
    saving: false, // Pour afficher le bouton "Saving"
  };

  async componentDidMount() {
    try {
      const response = await getCurrentInfo(); // Récupération des infos utilisateur via l'API
      const user = response.data;
      this.setState({
        values: {
          name: user.username,
          email: user.email,
        },
        loading: false,
      });
    } catch (error) {
      console.error('Error fetching user data:', error);
      this.setState({ loading: false });
    }
  }

  validateForm = _.debounce(() => {
    const { values } = this.state;
    const errors = validate(values, schema);

    this.setState({
      errors: errors || {},
      isValid: !errors,
    });
  }, 300);

  handleFieldChange = (field, value) => {
    this.setState(
      prevState => ({
        values: {
          ...prevState.values,
          [field]: value,
        },
        touched: {
          ...prevState.touched,
          [field]: true,
        },
      }),
      this.validateForm
    );
  };

  handleSave = async () => {
    try {
      const { values } = this.state;
      this.setState({ saving: true });

      await updateUser(values); // Met à jour l'utilisateur

      this.setState({ saving: false });
      window.alert('Profile saved');
    } catch (error) {
      console.error('Error updating user:', error);
      this.setState({ saving: false });
    }
  };

  render() {
    const { classes, className, ...rest } = this.props;
    const { values, touched, errors, isValid, loading, saving } = this.state;

    const showNameError = touched.name && errors.name ? errors.name[0] : false;
    const showEmailError = touched.email && errors.email ? errors.email[0] : false;
    const rootClassName = classNames(classes.root, className);

    if (loading) {
      return <CircularProgress className={classes.progress} />;
    }

    return (
      <Portlet {...rest} className={rootClassName}>
        <PortletHeader>
          <PortletLabel title="Profile" />
        </PortletHeader>
        <PortletContent noPadding>
          <form autoComplete="off" noValidate>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Name"
                margin="dense"
                required
                value={values.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText={showNameError && errors.name[0]}
                onChange={event => this.handleFieldChange('name', event.target.value)}
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Email Address"
                margin="dense"
                required
                value={values.email}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText={showEmailError && errors.email[0]}
                onChange={event => this.handleFieldChange('email', event.target.value)}
              />
            </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
          {saving ? (
            <CircularProgress className={classes.progress} />
          ) : (
            <Button color="primary" variant="contained" onClick={this.handleSave} disabled={!isValid}>
              Save profile
            </Button>
          )}
        </PortletFooter>
      </Portlet>
    );
  }
}

Account.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Account);
